<ion-card>
    <ion-card-content>
        <ion-label>Add items...</ion-label>
        <ion-fab vertical="center" horizontal="end" 
                 *ngIf="document.customer.name && document.documentNumber === 0">
            <ion-fab-button (tap)="equipProdModal()" size="small" color="light">
                <ion-icon name="add"></ion-icon>
            </ion-fab-button>
        </ion-fab>
    </ion-card-content>
    <!--    <ion-card-content (click)="equipProdModal()">-->
    <!--        <ion-button expand="full" shape="round" color="light">Select Detail Lines...</ion-button>-->
    <!--    </ion-card-content>-->
    <!--    <ion-fab vertical="top" horizontal="end">-->
    <!--        <ion-fab-button color="light" (click)="equipProdModal()" size="small">-->
    <!--            <ion-icon name="hammer"></ion-icon>-->
    <!--        </ion-fab-button>-->
    <!--    </ion-fab>-->
    <!-- TODO List headers? -->
    <ion-list *ngIf="document.detailLines.length > 0">
        <ion-item-sliding *ngFor="let item of document.detailLines; index as i;">

            <ion-item *ngIf="item.pdesc">
                <ion-label>{{item.overrideDescriptionNote}}</ion-label>
                <ion-input text-right type="number" [(ngModel)]="item.qty" (click)="$event.target.select()"></ion-input>
            </ion-item>

            <ion-item-options side="start">
                <ion-item-option color="none" float-right>
                    <ion-button (tap)="document.detailLines.splice(i,1)">
                        <ion-icon color="danger" name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>

            <ion-item-options side="start">
                <ion-item-option color="none" float-right>
                    <ion-button color="danger" (click)="document.detailLines.splice(i,1)">
                        <ion-icon name="trash" slot="icon-only"></ion-icon>
                    </ion-button>
                </ion-item-option>
            </ion-item-options>
        </ion-item-sliding>

    </ion-list>
</ion-card>
